export const validateDefault = {
  required: "入力して下さい。",
};
export const validateCheckBox = {
  required: "チェックして下さい。",
};

export const validateNon = {};
export const validateName = {
  required: "名前を入力してください。",
  minLength: { value: 1, message: "1文字以上で入力してください。" },
};
export const validateNumberic = {
  required: "入力してください",
  pattern: {
    value: /[0-9]*/,
    message: "数値で入力して下さい。",
  },
};
export const validateMail = {
  required: "メールアドレスを入力してください。",
  pattern: {
    value: /^[\w\-._]+@[\w\-._]+\.[A-Za-z]+/,
    message: "入力形式がメールアドレスではありません。",
  },
};
